import Cookies from 'js-cookie';

export const removeIntercomCookies = () => {
  Object.keys(Cookies.get()).forEach((cookieName) => {
    if (cookieName.includes('intercom')) {
      Cookies.remove(cookieName);
    }
  });
};
